<script lang="ts" setup>
import {type InterventionPreview, PublicationState} from '@/ts/types/dto/interventions-dto';
import {useI18n} from 'vue-i18n';
import BalmBtn from '@/vue/atoms/balm-btn.vue';
import SvgIllustration from '@/vue/atoms/svg-illustration.vue';

const {t: $t} = useI18n();

const props = defineProps<{
  intervention: InterventionPreview
}>();

</script>

<template>
  <div class="intervention-footer">
    <div v-if="props.intervention.publicationState === PublicationState.MAINTENANCE" class="label">
      <span>{{ `${$t('back_shortly')}` }}</span>
    </div>
    <div v-else-if="props.intervention.publicationState === PublicationState.PREVIEW" class="label">
      <span>{{ `${$t('coming_soon')}` }}</span>
    </div>
    <div v-else-if="props.intervention.publicationState === PublicationState.COMPLETED" class="label completed">
      <svg-illustration name="check.svg"/>
      <span>{{ `${$t('completed_on')}` }}</span>
    </div>
    <balm-btn
      v-else-if="PublicationState.IN_PROGRESS === intervention.publicationState"
      class="continue-btn"
      :label="$t('continue_path')"
      theme="light-white"
      paddings="p3-7"
      icon="arrow-narrow-right.svg"
    />
    <balm-btn
      v-else
      class="continue-btn"
      :label="$t('explore_path')"
      theme="light-white"
      paddings="p3-7"
      icon="arrow-narrow-right.svg"
    />
  </div>
</template>
<style scoped lang="scss">
.continue-btn {
  width: 100%;
}

.label {
  display: flex;
  @include font-body-bold;

  &.completed {
    > span {
      margin-left: var(--Spacing-spacing-2);
    }
  }
}

.intervention-footer {
  margin-top: var(--Spacing-spacing-5);
}
</style>
